export default __webpack_public_path__ + "static/media/icon-dish.fc84404a.svg";